// Public API of the directory module: other modules and the app import only from here.
// Pages stay out of the main bundle; the router loads them through `pages`.
export const pages = () => import("./pages");
export { strings } from "./i18n";
export { app } from "./app";
